export function fetchDefaultProviderFacility(facilities) {
  if (!facilities || facilities?.length === 0) {
    return null
  }
  let fac = facilities?.find((fac) => fac.favorite && fac.enabled)
  if (!fac) {
    fac = facilities.find((fac) => fac.enabled)
  }
  return fac?._id || null
}

export function updateTelehealthPOS(facility, placesOfService, telehealth) {
  if (telehealth) {
    const telehealthPOS = placesOfService?.find((pos) => pos?.code === '02' || pos?.code === '10')
    if (telehealthPOS) {
      return { place_of_service: telehealthPOS?.code }
    }
  } else {
    if (facility?.place_of_service) {
      const defaultPOS = placesOfService?.find((pos) => pos?.code === facility?.place_of_service)
      if (defaultPOS) {
        return { place_of_service: defaultPOS?.code }
      }
    }
  }

  return {}
}

export function getPOSDisplay(facility) {
  if (!facility) {
    return ''
  }
  const hasSinglePOS = facility.place_of_service && !facility.places_of_service
  return hasSinglePOS ? ` (${facility.place_of_service})` : ''
}
